import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const MortOuVifProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid mort-ou-vif-project container">
                <div className="flex">
                    {/*<img className="grid-img-1" src="/assets/img/homes/mort-ou-vif/02.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                    <svg className="grid-svg-1" x="0px" y="0px" width="92" height="849" viewBox="0 0 92 849">
                        <text className="mort-vif yrsa-li" x="0" y="8" fill="#000">
                            <tspan x="0">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">M</tspan>
                            <tspan x="0" dx="72">V</tspan>
                            <tspan x="0" dy="42">Mort.</tspan>
                            <tspan x="0" dx="72">Vif.</tspan>
                        </text>
                    </svg>
                </div>
                <div className="flex flex-container-1">
                    <svg className="grid-svg-2" x="0px" y="0px" width="294" height="620" viewBox="0 0 294 620">
                        <text className="barlow-it" x="0" y="8" fill="#828282">
                            <tspan x="0">v</tspan>
                            <tspan x="0" dy="61">i</tspan>
                            <tspan x="0" dy="61">f</tspan>
                            <tspan x="0" dx="72">v</tspan>
                            <tspan x="0" dx="72" dy="61">i</tspan>
                            <tspan x="0" dx="72" dy="61">f</tspan>
                            <tspan x="0" dx="144">v</tspan>
                            <tspan x="0" dx="144" dy="61">i</tspan>
                            <tspan x="0" dx="144" dy="61">f</tspan>
                            <tspan x="0" dx="216">v</tspan>
                            <tspan x="0" dx="216" dy="61">i</tspan>
                            <tspan x="0" dx="216" dy="61">f</tspan>
                            <tspan x="0" dx="288">v</tspan>
                            <tspan x="0" dx="288" dy="61">i</tspan>
                            <tspan x="0" dx="288" dy="61">f</tspan>
                        </text>
                    </svg>
                    {/*<img className="grid-img-2" src="/assets/img/homes/mort-ou-vif/03.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-2', asset: gridImages[2], sizes: ''}}/>
                </div>
                {/*<img className="grid-img-3" src="/assets/img/homes/mort-ou-vif/04.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-3', asset: gridImages[3], sizes: ''}}/>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Project</span> Mort ou Vif</li>
                            <li><span className="red barlow-me">Photographer</span> Olivier Foulon</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default MortOuVifProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(MortOuVifProjectGrid));


// WEBPACK FOOTER //
// ./src/components/MortOuVifProjectGrid.js